import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { ToastService } from '../services/toast-service';
import { AuthService } from '../auth/auth-service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  form: FormGroup;
  showPassword = false;

  constructor(private router: Router, private fb: FormBuilder, private toast: ToastService, private auth: AuthService) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    })
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  submit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    const { email, password } = this.form.value;

    this.auth.login(email!, password!)
      .then(() => {
        this.toast.showSuccess("Loggedin successfully");
        this.form.reset();
        this.router.navigate(['/'])
      })
      .catch((err: any) => {
        console.error(err);
        alert(err.message);
      });
  }

  // loginWithGoogle() {
  //   this.auth.googleLogin()
  //     .then(() => {
  //       console.log("Google login success");
  //     })
  //     .catch((err: any) => {
  //       console.error(err);
  //       alert(err.message);
  //     });
  // }
}
